import React from 'react';
import { Link, LinkProps } from 'react-router-dom';

import styled from 'styled-components';

//constants
import aampeTheme from '../../constants/aampeTheme';
import ICONS from '../../constants/icons';

// components
import BreadcrumbDropdown, { DropdownOption } from './BreadcrumbDropdown';

export interface BreadcrumbItem {
    label: string;
    value?: string;
    dropdownOptions?: DropdownOption[];
    customSelected?: DropdownOption | undefined;
}

interface BreadcrumbLinkProps extends LinkProps {
    isLast?: boolean;
}
interface BreadcrumbProps {
    breadcrumbs: BreadcrumbItem[] | undefined;
}

const Breadcrumb: React.FC<BreadcrumbProps> = ({ breadcrumbs }) => {
    return (
        <BreadcrumbContainer>
            <BreadcrumbLink isLast={false} to={'/'}>
                Home
            </BreadcrumbLink>
            <Separator>/</Separator>

            {breadcrumbs &&
                breadcrumbs.map((item, index) => (
                    <React.Fragment key={item.label}>
                        {item.dropdownOptions ? (
                            <>
                                <BreadcrumbWoLink>
                                    {item.label}:
                                </BreadcrumbWoLink>
                                <BreadcrumbDropdown
                                    options={item.dropdownOptions}
                                    customSelected={item.customSelected}
                                />
                                {index !== breadcrumbs.length - 1 && (
                                    <Separator>{index} </Separator>
                                )}
                            </>
                        ) : (
                            <>
                                {index !== breadcrumbs.length - 1 ? (
                                    <>
                                        <BreadcrumbLink
                                            to={item.value || '#'}
                                            isLast={
                                                index === breadcrumbs.length - 1
                                            }
                                        >
                                            {item.label}
                                        </BreadcrumbLink>
                                        {index !== breadcrumbs.length - 1 && (
                                            <Separator>{index} </Separator>
                                        )}
                                    </>
                                ) : (
                                    <BreadcrumbCurrent>
                                        {item.label}
                                    </BreadcrumbCurrent>
                                )}
                            </>
                        )}
                    </React.Fragment>
                ))}
        </BreadcrumbContainer>
    );
};

export default Breadcrumb;

const BreadcrumbContainer = styled.div({
    display: 'flex',
    alignItems: 'center',
    paddingBottom: aampeTheme.spacing4(2),
    gap: aampeTheme.spacing4(1),
    zIndex: 100,
    position: 'relative',
    lineHeight: '20px',
});

const Separator = styled(ICONS.rightChevron)({
    height: aampeTheme.spacing4(4),
    width: aampeTheme.spacing4(4),
    color: aampeTheme.colors.textAccessibleWG01,
});

/* eslint-disable @typescript-eslint/no-unused-vars */

const BreadcrumbLink = styled(({ isLast, ...rest }: BreadcrumbLinkProps) => (
    <Link {...rest} />
))<BreadcrumbLinkProps>`
    color: ${aampeTheme.colors.textAccessibleWG01};
    text-decoration: none;
    font-size: ${aampeTheme.size.font.textMedium};
    font-weight: ${(props) =>
        props.isLast ? aampeTheme.weights.medium : aampeTheme.weights.light};
`;
const BreadcrumbWoLink = styled.span({
    color: aampeTheme.colors.textAccessibleWG01,
    textDecoration: 'none',
    fontSize: aampeTheme.size.font.textMedium,
});

const BreadcrumbCurrent = styled.span({
    fontWeight: aampeTheme.weights.medium,
    textDecoration: 'none',
    fontSize: aampeTheme.size.font.textMedium,
    color: aampeTheme.colors.textAccessibleWG01,
});
